"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
var IconButton_1 = __importDefault(require("./IconButton"));
exports.IconButton = IconButton_1.default;
exports.default = IconButton_1.default;
//# sourceMappingURL=index.js.map